module.exports = __webpack_public_path__ + "img/UEEx-logo.d21f32bb.png";